var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 1.5C7.77614 1.5 8 1.27614 8 1C8 0.723858 7.77614 0.5 7.5 0.5H0.5C0.223857 0.5 0 0.723858 0 1V20C0 20.2761 0.223858 20.5 0.5 20.5H7.5C7.77614 20.5 8 20.2761 8 20C8 19.7239 7.77614 19.5 7.5 19.5H1V1.5H7.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6355 5.64995C11.8245 5.44863 12.1409 5.43866 12.3422 5.62767L17.1352 10.1277C17.2405 10.2266 17.2935 10.3603 17.293 10.4942C17.2935 10.6281 17.2405 10.7619 17.1352 10.8608L12.3422 15.3608C12.1409 15.5498 11.8245 15.5398 11.6355 15.3385C11.4465 15.1372 11.4564 14.8208 11.6578 14.6317L15.5321 10.9942H5.5C5.22386 10.9942 5 10.7704 5 10.4942C5 10.2181 5.22386 9.99422 5.5 9.99422H15.5321L11.6578 6.35671C11.4564 6.1677 11.4465 5.85127 11.6355 5.64995Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignout);
export default __webpack_public_path__ + "static/media/Signout.7b935dbfd7688a7d8b186cb37210c0df.svg";
export { ForwardRef as ReactComponent };